import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";
import { FaHouse, FaArrowRight } from "react-icons/fa6";
import "./Error.css";

const Error = () => {
  return (
    <div className="error-page-section">
      <Helmet>
        <title>404 - Page Not Found | Bharat Buildcon</title>
      </Helmet>
      {/* Dynamic Ambient Blur Glow Orbs */}
      <div className="error-bg-orb error-bg-orb--saffron" />
      <div className="error-bg-orb error-bg-orb--blue" />

      <div className="error-container">
        {/* 404 Hero Number */}
        <motion.div
          className="error-hero-visual"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          <span className="error-giant-text">404</span>
        </motion.div>

        {/* Main Title */}
        <motion.h1
          className="error-hero-title"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          Oops! Page <span className="error-gradient-text">Not Found</span>
        </motion.h1>

        {/* Subtitle */}
        <motion.p
          className="error-hero-subtitle"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          The page you are looking for might have been removed, had its name
          changed, or is temporarily unavailable.
        </motion.p>

        {/* Primary CTA */}
        <motion.div
          className="error-cta-wrapper"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <Link to="/" className="error-btn-main">
            <FaHouse />
            <span>Back to Home</span>
            <FaArrowRight className="arrow-icon" />
          </Link>
        </motion.div>
      </div>
    </div>
  );
};

export default Error;
